/* @flow */

import * as React from 'react';

import {BaseRow} from '../../row';
import {type BaseRowStatusBadge, type ToolbarProps} from '../../row/base-row/base-row';
import type {TertiaryActionProps} from '../../row/base-row/tertiary-action';
import {type SelectMenuOption} from '../../select-menu';

import {ContactCardContents} from './contact-card-contents';

type Props = {|
    name: ?string,
    description: ?string,
    role?: ?string,
    phoneNumber: ?string,
    phoneExtension?: ?string,
    email: ?string,
    lastContactedTime?: ?string,
    icon: React.Node,
    tertiaryProps?: TertiaryActionProps,
    actionMenuOptions?: Array<SelectMenuOption>,
    contactUrl?: ?string,
    // This should always be the ConnectButtonsRow component, it was required to be a prop
    // to allow ContactCard to be a shell due to hooks being called in SmsSidebarButton
    connectButtonsRow?: React.Node,
    statusBadges?: BaseRowStatusBadge[],
    toolbarProps?: ToolbarProps,
|};

export function ContactCard(props: Props) {
    return (
        <BaseRow
            title={props.name || `Unnamed person`}
            type='contacts'
            customIcon={props.icon}
            tertiaryProps={props.tertiaryProps}
            actionMenuOptions={props.actionMenuOptions}
            url={props.contactUrl || undefined}
            statusBadges={props.statusBadges}
            toolbarProps={props.toolbarProps}
        >
            <ContactCardContents
                description={props.description}
                role={props.role}
                phoneNumber={props.phoneNumber}
                phoneExtension={props.phoneExtension}
                email={props.email}
                lastContactedTime={props.lastContactedTime}
                connectButtonsRow={props.connectButtonsRow}
            />
        </BaseRow>
    );
}
